import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/lib/i18n";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminQuotes from "@/pages/AdminQuotes";
import AdminCalendar from "@/pages/AdminCalendar";
import PublicQuote from "@/pages/PublicQuote";
import Terms from "@/pages/legal/Terms";
import RefundPolicy from "@/pages/legal/RefundPolicy";
import Privacy from "@/pages/legal/Privacy";
import TermsHr from "@/pages/legal/TermsHr";
import RefundPolicyHr from "@/pages/legal/RefundPolicyHr";
import PrivacyHr from "@/pages/legal/PrivacyHr";
import DriverLogin from "@/pages/DriverLogin";
import DriverSetup from "@/pages/DriverSetup";
import DriverDashboard from "@/pages/DriverDashboard";
import DriverHistory from "@/pages/DriverHistory";
import DriverDocuments from "@/pages/DriverDocuments";
import DriverProfile from "@/pages/DriverProfile";
import DriverBenefits from "@/pages/DriverBenefits";
import AdminDrivers from "@/pages/AdminDrivers";
import AdminPayouts from "@/pages/AdminPayouts";
import DepositPage from "@/pages/DepositPage";
import DepositSuccess from "@/pages/DepositSuccess";
import PartnerPortal from "@/pages/PartnerPortal";
import ContractSign from "@/pages/ContractSign";
import SupplierAction from "@/pages/SupplierAction";
import ExperiencePay from "@/pages/ExperiencePay";
import AdminSelfBilling from "@/pages/AdminSelfBilling";
import AdminSepa from "@/pages/AdminSepa";
import DriverStatements from "@/pages/DriverStatements";
import B2BLanding from "@/pages/B2BLanding";
import DestinationsPage from "@/pages/Destinations";
import ExperiencesPage from "@/pages/Experiences";
import PartnersPage from "@/pages/Partners";
import AdminInquiries from "@/pages/AdminInquiries";
import AdminSuppliers from "@/pages/AdminSuppliers";
import AdminDriverApplications from "@/pages/AdminDriverApplications";
import AdminPricing from "@/pages/AdminPricing";
import AdminAnalytics from "@/pages/AdminAnalytics";
import AdminControlRoom from "@/pages/AdminControlRoom";
import AdminDispatch from "@/pages/AdminDispatch";
import DriverOffer from "@/pages/DriverOffer";
import BecomeDriver from "@/pages/BecomeDriver";
import DriverOnboarding from "@/pages/DriverOnboarding";
import RateDriver from "@/pages/RateDriver";
import CookieConsent from "@/components/CookieConsent";

function App() {
  return (
    <div className="App">
      <LangProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/quotes" element={<AdminQuotes />} />
            <Route path="/admin/calendar" element={<AdminCalendar />} />
            <Route path="/quote/:ref" element={<PublicQuote />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/hr/terms" element={<TermsHr />} />
            <Route path="/hr/refund-policy" element={<RefundPolicyHr />} />
            <Route path="/hr/privacy" element={<PrivacyHr />} />
            <Route path="/driver" element={<DriverLogin />} />
            <Route path="/driver/setup" element={<DriverSetup />} />
            <Route path="/driver/dashboard" element={<DriverDashboard />} />
            <Route path="/driver/history" element={<DriverHistory />} />
            <Route path="/driver/documents" element={<DriverDocuments />} />
            <Route path="/driver/profile" element={<DriverProfile />} />
            <Route path="/driver/benefits" element={<DriverBenefits />} />
            <Route path="/driver/obracuni" element={<DriverStatements />} />
            <Route path="/admin/drivers-manage" element={<AdminDrivers />} />
            <Route path="/admin/payouts" element={<AdminPayouts />} />
            <Route path="/admin/self-billing" element={<AdminSelfBilling />} />
            <Route path="/admin/sepa" element={<AdminSepa />} />
            <Route path="/deposit/success" element={<DepositSuccess />} />
            <Route path="/deposit/:ref" element={<DepositPage />} />
            <Route path="/b2b" element={<B2BLanding />} />
            <Route path="/b2b/login" element={<PartnerPortal />} />
            <Route path="/b2b/dashboard" element={<PartnerPortal />} />
            <Route path="/b2b/sign-contract/:token" element={<ContractSign />} />
            <Route path="/supplier/sign-contract/:token" element={<ContractSign kind="supplier" />} />
            <Route path="/supplier/request/:token" element={<SupplierAction />} />
            <Route path="/experiences/pay/:payToken" element={<ExperiencePay />} />
            <Route path="/destinations" element={<DestinationsPage />} />
            <Route path="/destinations/:slug" element={<DestinationsPage />} />
            <Route path="/experiences" element={<ExperiencesPage />} />
            <Route path="/partners" element={<PartnersPage />} />
            <Route path="/suppliers" element={<PartnersPage />} />
            <Route path="/admin/inquiries" element={<AdminInquiries />} />
            <Route path="/admin/suppliers" element={<AdminSuppliers />} />
            <Route path="/admin/driver-applications" element={<AdminDriverApplications />} />
            <Route path="/admin/pricing" element={<AdminPricing />} />
            <Route path="/admin/analytics" element={<AdminAnalytics />} />
            <Route path="/admin/control-room" element={<AdminControlRoom />} />
            <Route path="/admin/dispatch" element={<AdminDispatch />} />
            <Route path="/driver/offer/:offerId" element={<DriverOffer />} />
            <Route path="/postani-vozac" element={<BecomeDriver />} />
            <Route path="/driver-onboarding" element={<DriverOnboarding />} />
            <Route path="/rate/:ref" element={<RateDriver />} />
            <Route path="/become-a-driver" element={<BecomeDriver />} />
          </Routes>
          <CookieConsent />
        </BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: "#121212",
              border: "1px solid rgba(197, 160, 89, 0.3)",
              color: "#fafafa",
            },
          }}
        />
      </LangProvider>
    </div>
  );
}

export default App;
